module.exports = __webpack_public_path__ + "media/images/number_5_green-5d2cab4b79a6179a8eda87de422b38a0.png";